import {
    Alert,
    Box,
    Button, Checkbox,
    ClickAwayListener,
    Fade,
    FormControlLabel, Grid,
    IconButton,
    InputAdornment,
    Modal,
    Paper,
    Stack,
    Tab,
    Tabs,
    TextField,
    Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import TabPanel from "./tabPanel";
import PhoneTextField from "../../theme/components/PhoneTextField";
import AuthCodeInput from "../../theme/components/AuthCodeInput";
import http from "../../lib/services/httpService";
import { VisibilityOffRounded, VisibilityRounded } from "@mui/icons-material";
import { LoadingButton } from "../../theme/components/LoadingButton";
import { useUser } from "../../lib/hooks";
import Toasty from "../../theme/components/Toasty";
import { setRefreshToken, setToken, setUserData } from "../../lib/services/jwtService";
import useMainStore from "../../store";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import { useNavigate } from "react-router-dom";
import useAppConfig from "../../store/appConfig";

const LoginModal = (props) => {

    const { onClose = () => null, options = {}, ...restProps } = props;
    const { noReload, onSuccess } = options;

    //  Initial Props
    const [tabIndex, setTabIndex] = useState(0);
    const [inputData, setInputData] = useState({
        phoneNumber: '',
        maskedNumber: {},
        verifyCode: '',
        username: '',
        password: '',
        laws: true,
        showPassword: false,
    });
    const [verifying, setVerifying] = useState(false);
    const [resendTimer, setResendTimer] = useState(120);
    const [isCaptchaChecked, setIsCaptchaChecked] = useState(false);

    const [pending, setPending] = useState(false);
    const [resendPending, setResendPending] = useState(false);
    const [errors, setErrors] = useState([]);
    const [success, setSuccess] = useState(false);

    const submitBtnRef = useRef(null);
    const maxVerifyCodeLength = 5;
    const apiUrl = useAppConfig(state => state.apiUrl);

    const user = useUser();
    const { setSessionUpdated } = useMainStore();
    const navigate = useNavigate();

    const handleChangeInput = (e) => {
        const { target: { value, name } } = e;
        if (errors?.length) setErrors(null);
        const newData = { ...inputData };
        newData[name] = value;
        setInputData(newData);
    };
    const handlePhoneInputChange = (number, { dialCode }) => {
        if (errors?.length) setErrors(null);
        const newData = { ...inputData };
        newData.phoneNumber = number;
        newData.maskedNumber.mobileNumber = number.replace(dialCode, '0');
        newData.maskedNumber.countryCode = `00${dialCode}`;
        setInputData(newData);
    };
    const handleChangeAuthInput = (number) => {
        if (errors?.length) setErrors(null);
        const newData = { ...inputData };
        newData.verifyCode = number;
        setInputData(newData);
    };

    const handleGotoVerification = async (e) => {
        e.preventDefault();
        const { phoneNumber, maskedNumber } = inputData;
        if (!phoneNumber || maskedNumber.mobileNumber === '0') return setErrors(['شماره موبایل وارد شده صحیح نمی باشد']);
        // if (!isCaptchaChecked) errors.push('لطفا کپچا را تایید کنید');
        if (errors?.length) return;
        setPending(true);
        const { data } = await http.post(`${apiUrl}/user/LoginWithMobile`, inputData.maskedNumber);
        if (data?.isSuccess) {
            setVerifying(true);
        } else {
            setErrors(data.errors);
        }
        setPending(false);
    };
    const handleLoginWithMobile = async (e) => {
        e.preventDefault();
        // if (user) return;
        const { verifyCode } = inputData;
        if (!verifyCode || maxVerifyCodeLength !== verifyCode?.length) return setErrors(['لطفا کد اعتبار سنجی را وارد کنید']);
        if (errors?.length) return;
        setPending(true);
        const { data } = await http.post(`${apiUrl}/user/VerifyVerificationCode`, { ...inputData.maskedNumber, code: verifyCode });
        if (data?.isSuccess) {
            const userData = data.value
            const { access_Token: accessToken, refresh_Token } = userData;
            setToken(accessToken);
            setRefreshToken(refresh_Token);
            axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
            delete userData.refresh_Token;
            delete userData.access_Token;
            userData.role = 'user';
            setUserData(JSON.stringify(userData));
            setSuccess(true);
            setSessionUpdated();
            onClose();
            if (!noReload) navigate('/drive');
            if (onSuccess && typeof onSuccess === 'function') onSuccess(e);
        } else {
            setErrors(data.errors);
        }
        setPending(false);
    };
    const handleLoginWithEmail = async (e) => {
        e.preventDefault();
        // if (user) return;
        const { username, password } = inputData;
        let errors = [];
        if (!username) errors.push('لطفا نام کاربری را وارد کنید');
        if (!password) errors.push('لطفا رمز عبور را وارد کنید');
        // if (!isCaptchaChecked) errors.push('لطفا کپچا را تایید کنید');
        if (errors.length) return setErrors(errors);
        setPending(true);
        const { data } = await http.post(`${apiUrl}/user/LoginWithEmail`, { username, password });
        if (data?.isSuccess) {
            const userData = data.value
            const { access_Token: accessToken, refresh_Token } = userData;
            setToken(accessToken);
            setRefreshToken(refresh_Token);
            axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
            delete userData.refresh_Token;
            delete userData.access_Token;
            userData.role = 'user';
            setUserData(JSON.stringify(userData));
            setSuccess(true);
            setSessionUpdated();
            Toasty.success('شما با موفقیت وارد حسابتان شدید');
            onClose();
            if (!noReload) navigate('/drive');
            if (onSuccess && typeof onSuccess === 'function') onSuccess(e);
        } else {
            setErrors(data.errors);
        }
        setPending(false);
    };
    const handleResendCode = async (e) => {
        setResendPending(true);
        await handleGotoVerification(e);
        setResendTimer(120);
        setResendPending(false);
    };

    function onCaptchaChange(value) {
        setIsCaptchaChecked(Boolean(value));
    }

    function getMinutes(seconds) {
        const value = parseInt(seconds / 60, 10);
        return value.toLocaleString('fa-IR').padStart(2, '۰');
    }
    function getSeconds(seconds) {
        const value = parseInt(seconds % 60, 10);
        return value.toLocaleString('fa-IR').padStart(2, '۰');
    }
    const handleCheckboxChange = (e) => {
        const { target: { checked, name } } = e;
        setInputData({ ...inputData, [name]: checked });
    }

    // Resend Verification Code Timer
    useEffect(() => {
        const newValue = resendTimer - 1;
        const timerInterval = setInterval(() => {
            if (!verifying) return;
            setResendTimer(newValue);
        }, 1000);
        if (newValue < 0) clearInterval(timerInterval);
        return () => clearInterval(timerInterval);
    }, [resendTimer, verifying]);

    return (
        <Modal {...restProps}>
            <Box width={1} height={1} display="flex" alignItems="center" justifyContent="center">
                <ClickAwayListener onClickAway={onClose}>
                    <Paper elevation={25} sx={{ width: { xs: "90%", lg: "auto" }, minWidth: { lg: "25%" }, maxWidth: { xs: "90%", lg: "85%", xl: "75%", xxl: "65%" }, maxHeight: "90%", minHeight: "50%", p: 2.5, borderRadius: 2.5, overflowY: "auto" }}>
                        <Tabs value={tabIndex} onChange={(e, newValue) => { setErrors(null); setTabIndex(newValue) }} centered>
                            <Tab disabled={pending} label="ورود با موبایل" />
                            <Tab disabled={pending} label="ورود با حساب میلفا" />
                        </Tabs>
                        <Box mt={3}>
                            {/* Login With Mobile */}
                            <TabPanel index={0} value={tabIndex}>
                                {!verifying
                                    ?
                                    // Enter Number
                                    <Stack component="form" onSubmit={handleGotoVerification} spacing={2} sx={{ direction: "rtl" }}>
                                        <Typography fontSize=".85rem" fontWeight={500} textAlign="center">ورود / ثبت نام با موبایل</Typography>
                                        <PhoneTextField
                                            value={inputData.phoneNumber} onChange={handlePhoneInputChange}
                                            name="phoneNumber" label="شماره موبایل" placeholder="+98 912 123 4567"
                                            inputProps={{ name: 'phone', required: true, autoFocus: true, country: "ir" }} InputLabelProps={{ shrink: !!inputData.phoneNumber }}
                                            error={!!errors?.length} fullWidth />
                                        <Alert severity="info" sx={{ direction: "ltr", fontSize: ".8rem" }}>شماره خود را بدون صفر وارد کنید، مثال: ۹۱۲۱۲۳۴۵۶۷</Alert>
                                        <Box sx={{ direction: "ltr" }}>
                                            {/*<ReCAPTCHA*/}
                                            {/*    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}*/}
                                            {/*    theme={themeMode}*/}
                                            {/*    onChange={onCaptchaChange}/>*/}
                                        </Box>
                                        <LoadingButton
                                            loading={pending && !resendPending}
                                            type="submit" fullWidth
                                            variant="contained" sx={{ mt: 2.5, py: 1.5 }} disableElevation>مرحله بعد</LoadingButton>
                                    </Stack>
                                    :
                                    // Verification
                                    <Stack component="form" onSubmit={(e) => handleLoginWithMobile(e)} spacing={2}>
                                        <Alert severity="success">کد اعتبار سنجی با موفقیت ارسال شد</Alert>
                                        <Typography fontSize=".85rem" fontWeight={500} textAlign="center">لطفا کد ارسال شده را وارد کنید</Typography>
                                        <AuthCodeInput
                                            onChange={handleChangeAuthInput} onCompleted={async (newNumber) => { await handleChangeAuthInput(newNumber); submitBtnRef.current.click() }}
                                            InputProps={{ length: maxVerifyCodeLength, allowedCharacters: "numeric" }} />
                                        <Box display="flex" alignItems="center" justifyContent="space-between" flexDirection={{ xs: "column", md: "row" }}>
                                            <Typography fontSize=".8rem" fontWeight={300}>شماره وارد شده: {inputData?.maskedNumber?.mobileNumber}</Typography>
                                            <Box display="flex" alignItems="center" justifyContent="flex-end">
                                                <Typography fontSize=".9rem" fontWeight={300}>{`${getMinutes(resendTimer)}:${getSeconds(resendTimer)}`}</Typography>
                                                <LoadingButton
                                                    loading={resendPending} variant="text"
                                                    onClick={handleResendCode} disabled={Boolean(resendTimer > 0)}
                                                    sx={{ fontSize: ".8rem", ml: 2 }}>ارسال مجدد کد</LoadingButton>
                                            </Box>
                                        </Box>
                                        <Box>
                                            <LoadingButton
                                                loading={pending && !resendPending} success={success}
                                                ref={submitBtnRef} type="submit" variant="contained"
                                                fullWidth sx={{ py: 1.5 }} disableElevation>ورود</LoadingButton>
                                            <Button onClick={() => { setVerifying(false); setErrors(null); setPending(false) }} variant="outlined" fullWidth sx={{ mt: 1, py: 1.5 }} disableElevation>بازگشت</Button>
                                        </Box>
                                    </Stack>
                                }
                                <Fade in={!!errors?.length}>
                                    <Stack mt={2.5} spacing={1} sx={{ direction: "ltr" }}>
                                        {errors?.map((err, index) => (
                                            <Alert key={index} severity="error">{err}</Alert>
                                        ))}
                                    </Stack>
                                </Fade>
                            </TabPanel>
                            {/* Login With Email */}
                            <TabPanel index={1} value={tabIndex}>
                                <Stack component="form" onSubmit={handleLoginWithEmail} spacing={2} noValidate>
                                    <TextField
                                        value={inputData.username} onChange={handleChangeInput}
                                        fullWidth name="username"
                                        label="نام کاربری" placeholder="نام کاربری خود را وارد کنید" required />
                                    <TextField
                                        value={inputData.password} onChange={handleChangeInput}
                                        fullWidth name="password" type={inputData.showPassword ? 'text' : 'password'}
                                        label="رمز عبور" placeholder="رمز عبور خود را وارد کنید" required
                                        InputProps={{
                                            endAdornment:
                                                <InputAdornment position="start">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={() => setInputData({ ...inputData, showPassword: !inputData.showPassword })}
                                                        onMouseDown={(e) => e.preventDefault()}
                                                        edge="end">
                                                        {inputData.showPassword ? <VisibilityOffRounded /> :
                                                            <VisibilityRounded />}
                                                    </IconButton>
                                                </InputAdornment>
                                        }} />
                                    {/*<ReCAPTCHA*/}
                                    {/*    sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}*/}
                                    {/*    theme={themeMode}*/}
                                    {/*    onChange={onCaptchaChange}/>*/}
                                    <LoadingButton
                                        loading={pending} success={success}
                                        type="submit" variant="contained" fullWidth
                                        sx={{ py: 1.5 }} disableElevation>ورود</LoadingButton>
                                    <a href={'https://mailfa.com/email/create'} style={{ margin: "auto" , marginTop: "1rem"}} target={"_blank"}>ساخت ایمیل</a>
                                </Stack>
                                <Fade in={!!errors?.length}>
                                    <Stack mt={2.5} spacing={1} sx={{ direction: "ltr" }}>
                                        {errors?.map((err, index) => (
                                            <Alert key={index} severity="error">{err}</Alert>
                                        ))}
                                    </Stack>
                                </Fade>
                            </TabPanel>
                        </Box>


                        <Grid my={1} container spacing={1}>
                            <Grid item xs={12} lg={6}>
                                <FormControlLabel control={<Checkbox name="laws" checked={inputData.laws} onChange={handleCheckboxChange} />} label="با قوانین و مقررات موافقم." />
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Button onClick={() => {  }} variant="outlined" fullWidth sx={{ py: 1.5 }} disableElevation>مشاهده قوانین و مقررات</Button>
                            </Grid>
                        </Grid>


                    </Paper>
                </ClickAwayListener>
            </Box>
        </Modal>
    )
}
export default LoginModal;
